<template>
  <div class="checkbox-container">
    <label class="form-group form-check text-left">
      <p v-if="label || $slots.default" class="ml-5">
        <span v-if="label && !$slots.default">{{ label }}</span>
        <slot v-else></slot>
      </p>

      <input
        v-if="legacy"
        type="checkbox"
        :name="name"
        class="form-check-input"
        :checked="value"
        @change="updateValue"
        @input="updateValue"
        :disabled="disabled"
        :data-cy="dataCy"
      />

      <input v-else type="checkbox" :name="name" :value="arrayValue" class="form-check-input" v-model="computedValue" />
      <span
        class="checkmark"
        :class="{ 'checkmark-lg': size === 'lg', 'checkmark-md': size === 'md', 'checkmark-sm': size === 'sm' }"
      ></span>
    </label>

    <div v-if="error" class="error-message text-danger">
      <span class="error-icon"></span>
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
  },

  props: {
    disabled: Boolean,
    value: [Boolean, Array],
    legacy: {
      type: Boolean,
      default: true,
    },
    arrayValue: {
      type: String,
    },
    label: String,
    name: {
      type: String,
      default: 'checkbox',
    },
    size: {
      type: String,
      default: 'lg',
    },
    error: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: val => {
        return ['text', 'checkbox'].indexOf(val) !== -1;
      },
    },
    dataCy: {
      type: String,
      required: false,
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    updateValue(e) {
      this.$emit('input', e.target.checked);
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox-container {
  position: relative;
  width: 100%;
  display: inline-block;
}

// custom checkbox
/* Hide the browser's default checkbox */
.form-check {
  position: static;
}

.form-check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  background-color: #fff;
  border-radius: $border-radius;
  transition: $transition-base;
}

.checkmark-lg {
  top: 0;
  border: 2px solid $gray-500;
  height: 25px;
  width: 25px;
}

.checkmark-md {
  top: 2px;
  border: 2px solid $gray-500;
  height: 20px;
  width: 20px;
}

.checkmark-sm {
  top: 3px;
  border: 1px solid $gray-500;
  height: 15px;
  width: 15px;
  min-width: 15px;
}

.form-check input:disabled ~ .checkmark {
  background: $gray-100 !important;
  background-image: url('../../../../../icons/custom/dash.svg') !important;
  color: pink;
  background-size: 7px !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  border: 1px solid $gray-600 !important;
  cursor: not-allowed;
}

/* On mouse-over, add a grey background color */
.form-check:hover input ~ .checkmark {
  border: 2px solid $primary;
}

/* When the checkbox is checked, add a blue background */
.form-check input:checked ~ .checkmark {
  background-color: $primary;
  border: 2px solid $primary;
  background-image: url('../../../../../icons/custom/checkmark.svg');
  background-size: 10px;
  background-position: center center;
  background-repeat: no-repeat;
}

.checkbox-round {
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #ddd;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}

.checkbox-round:checked {
  background-color: gray;
}

// end of custom checkbox
</style>
